import { HAS_ACTIVE_HIGHLIGHT_CLASS } from '../constants';

const STYLES_ID = 'selections-highlight-styles';
const STYLES_CSS = `
  .${HAS_ACTIVE_HIGHLIGHT_CLASS} [data-testid="insert-field-dot"],
  .${HAS_ACTIVE_HIGHLIGHT_CLASS} [data-testid^="add-entry-dot"] {
    opacity: 0 !important;
    pointer-events: none !important;
  }
`;

export class HighlightStyleManager {
  #styleElement: HTMLStyleElement | null = null;

  add(): void {
    if (document.getElementById(STYLES_ID)) {
      return;
    }

    this.#styleElement = document.createElement('style');
    this.#styleElement.id = STYLES_ID;
    this.#styleElement.textContent = STYLES_CSS;
    document.head.appendChild(this.#styleElement);
  }

  remove(): void {
    if (this.#styleElement) {
      this.#styleElement.remove();
      this.#styleElement = null;
    }
  }
}
